import { assets } from "./assets/assets";

export const skills = {
  front: [
    { name: "React", icon: assets.react, rate: 90 },
    { name: "Redux", icon: assets.redux, rate: 80 },
    { name: "Javascript", icon: assets.javascript, rate: 80 },
    { name: "HTML", icon: assets.html, rate: 80 },
    { name: "CSS", icon: assets.css, rate: 70 },
    { name: "Bootstrap", icon: assets.bootstrap, rate: 60 },
  ],
  back: [
    { name: "NodeJS", icon: assets.node, rate: 80 },
    { name: "Express", icon: assets.express, rate: 80 },
    { name: "PostgreSQL", icon: assets.postgresql, rate: 80 },
    { name: "MongoDB", icon: assets.mongodb, rate: 70 },
    { name: "Firebase", icon: assets.firebase, rate: 70 },
  ],
};

export const projects = [
  {
    name: "Watchuseek",
    type: "Web / eCommerce",
    functions:
      "Shopping cart, CRUD user/product, dashboard, profile, validations, third-party auth, reviews/comments, checkout.",
    tools: [
      "react",
      "redux",
      "bootstrap",
      "node",
      "postgresql",
      "express",
      "google",
      "jwt",
      "mailgun",
    ],
    link: "https://github.com/karlofsd/Watchuseek",
  },
  {
    name: "ML Search!",
    type: "Web / App",
    functions:
      "API call of MELI products, filter panel, caché storage.",
    tools: [
        "react",
        "css",
        "node",
        "redux",
        "express",
        "javascript",
      ],
    link: "https://github.com/karlofsd/MLsearch",
  },
  {
    name: "Henry Comics",
    type: "Web / eCommerce",
    functions:
      "Shopping cart, CRUD user/products, dashboard, profile, validations, third-party auth, reviews/comments, checkout, wishlist, mercadopago.",
    tools: [
        "react",
        "redux",
        "bootstrap",
        "css",
        "node",
        "postgresql",
        "express",
        "passport",
        "jwt",
        "nodemailer",
      ],
    link: "https://github.com/karlofsd/Henry-Comics",
  },
  {
    name: "MoonBank",
    type: "Web / eWallet",
    functions:
      "Login/Register, balance, card storage, contacts, services, resume, dollars.",
    tools: ["react", "redux", "css", "firebase", "expo"],
    link: "https://github.com/karlofsd/MoonBank",
  },
  {
    name: "TaGallery",
    type: "Web / App",
    functions:
      "CRUD tags, API call and database, realtime CRUD",
    tools: ["react", "css", "node", "mongodb", "express", "socket"],
    link: "https://github.com/karlofsd/TaGallery",
  },
];
